// src/features/selectedDate/selectedDateSelectors.ts

import { RootState } from "@core/store"

export const selectedDateSelector = (state: RootState) =>
  state.selectedDate.selectedDate
